import Vue from 'vue'
import Vuex from 'vuex'
import { alert } from './store/alert.module';
import { account } from './store/account.module';
import { pois } from './store/pois.module';
import { categories } from './store/categories.module';
import { stats } from './store/stats.module';
import { configurations } from './store/configuration.module';
import { products } from './store/products.module';
import { orders } from './store/orders.module';
import { heros } from './store/heros.module';
import { keyValues } from './store/keyValues.module';
import { members } from './store/members.module';
import { experiences } from './store/experiences.module';
import { testimonials } from './store/testimonials.module';

Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  }
}

export default new Vuex.Store({
  namespaced: true,
  state,
  mutations,
  modules: {
    alert,
    account,
    pois,
    categories,
    stats,
    configurations,
    products,
    orders,
    heros,
    keyValues,
    members,
    experiences,
    testimonials
  }
});